import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./CookieConsent.scss";

const STORAGE_KEY = "gluck-cookie-consent";

function CookieConsent() {
	const { t } = useTranslation();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		try {
			const saved = localStorage.getItem(STORAGE_KEY);
			if (!saved) {
				setIsVisible(true);
			}
		} catch {
			setIsVisible(true);
		}
	}, []);

	const saveChoice = (value) => {
		try {
			localStorage.setItem(STORAGE_KEY, value);
		} catch {
			/* ignore */
		}
		setIsVisible(false);
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="cookie-consent" role="dialog" aria-live="polite">
			<div className="cookie-consent__panel">
				<p className="cookie-consent__text">{t("cookies.message")}</p>
				<div className="cookie-consent__actions">
					<button
						type="button"
						className="cookie-consent__btn cookie-consent__btn--accept"
						onClick={() => saveChoice("accepted")}
					>
						{t("cookies.accept")}
					</button>
					<button
						type="button"
						className="cookie-consent__btn cookie-consent__btn--decline"
						onClick={() => saveChoice("declined")}
					>
						{t("cookies.decline")}
					</button>
				</div>
			</div>
		</div>
	);
}

export default CookieConsent;
